<div class="register-choice-container">

  <table>

    <tr>
      <td>
        <img alt="" class="check-icon" src="./assets/images/blue_check_icon.png">
      </td>
      <td>
        {{getString('completelyFree')}}
      </td>
    </tr>

    <tr>
      <td>
        <img alt="" class="check-icon" src="./assets/images/blue_check_icon.png">
      </td>
      <td>
        {{getString('emailNotifications')}}
      </td>
    </tr>

    <tr>
      <td>
        <img alt="" class="check-icon" src="./assets/images/blue_check_icon.png">
      </td>
      <td>
        {{getString('wishlistSync')}}
      </td>
    </tr>

    <tr>
      <td>
        <img alt="" class="check-icon" src="./assets/images/blue_check_icon.png">
      </td>
      <td>
        {{getString('noSpam')}}
      </td>
    </tr>

  </table>

  <div class="form-field">
    <button class="register-now blue-button" type="button" (click)="registerNow()">{{getString('registerNow')}}</button>
  </div>

  <div class="or-container">
    {{getString('or')}}
  </div>

  <div class="fb-btn-container">
    <app-facebook-login-button (onClick)="FBLogin()"></app-facebook-login-button>
    <app-sign-in-apple></app-sign-in-apple>
  </div>

  <div class="login-btn">
    <a (click)="loginClick()">{{getString('login')}}</a>
  </div>

</div>
